import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { get } from "../../lib/request"

// GET /api/v1/client-note/types
export const fetchClientNoteTypes = createAsyncThunk(
  "clientNoteTypes/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const res = await get("client-notes/types")
      return res?.data || res || []
    } catch (err) {
      return rejectWithValue(err?.message || "Failed to fetch note types")
    }
  }
)

const initialState = {
  types: [],
  status: "idle",
  error: null,
}

const clientNoteTypesSlice = createSlice({
  name: "clientNoteTypes",
  initialState,
  reducers: {
    clearClientNoteTypes: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClientNoteTypes.pending, (state) => {
        state.status = "loading"
        state.error = null
      })
      .addCase(fetchClientNoteTypes.fulfilled, (state, action) => {
        state.status = "succeeded"
        state.types = Array.isArray(action.payload) ? action.payload : []
      })
      .addCase(fetchClientNoteTypes.rejected, (state, action) => {
        state.status = "failed"
        state.error = action.payload
      })
  },
})

export const { clearClientNoteTypes } = clientNoteTypesSlice.actions
export default clientNoteTypesSlice.reducer
